<template>
  <card>
    <div class="card-header pt-0">
      <h4 class="title mt-0">
        Other Comments & Recommendations
      </h4>
    </div>
    <fg-input>
      <label for="comments">Comments & Recommendations to put on the Closeout Report</label>
      <textarea
        style="max-height=100px;"
        class="form-control"
        placeholder="Anything about the council, curriculum, course, tickets, etc."
        id="comments"
        v-model="course.CloseoutComments"
        rows="6"
      />
    </fg-input>
    <div v-if="isSmallCourse">
      <p>Small Course Approval Information</p>
      <div class="row">
        <div class="col-6">
          <fg-input
            name="smallApproval"
            label="Small Course Approved By"
            v-model="course.SmallCourseApprovalName"
          />
        </div>
        <div class="col-6">
          <fg-input
            name="smallTitle"
            label="Approver's Title"
            v-model="course.SmallCourseApprovalTitle"
          />
        </div>
      </div>
      <fg-input>
        <label for="smallComments">Comments</label>
        <textarea
          style="max-height=100px;"
          class="form-control"
          placeholder="Comments including any reasoning provided for small course approval"
          id="comments"
          v-model="course.SmallCourseApprovalComments"
          rows="6"
        />
      </fg-input>
    </div>
    <button
      class="btn btn-primary"
      @click="update"
    >
      Submit
    </button>
  </card>
</template>

<script>
import courseApi from '@/services/api/course.js'

export default {
  name: 'ReportCloseoutOtherCommentsEdit',
  props: {
    isSmallCourse: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      course: {}
    }
  },
  mounted: function () {
    courseApi
      .get(this.$root.courseKey)
      .then(x => {
        this.course = x
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    update: function () {
      courseApi
        .update(this.course)
        .then(x => {
          this.course = x
          this.$notify({
            message: 'Update complete.',
            icon: 'nc-icon nc-satisfied',
            type: 'success',
            horizontalAlign: 'center',
            timeout: 2000
          })
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error saving your comments.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
